module.exports = __webpack_public_path__ + "img/intercom_odd.7ea5a61e.svg";